/* eslint-disable no-param-reassign */
import {
    getBankItemNames,
    getDepositItemNames,
    getFormItemNames,
    getItemNames,
    getTermItemNames,
} from "../../../helpers/getAutosaveTransactionItemNames";

/**
 * Check all List related items (eg account, product) in transaction's table items, which
 * includes form_items, items, bank_items, journal_items, term_items, deposit_items.
 * @param {*} transaction
 * @param {*} type String, the table name, eg 'form_items', 'deposit_items', etc.
 * @returns an object with arrays of all invalid items' names/label.
 */
export function parseTransactionTableItems(transaction = {}, type = null) {
    const invalidObj = {
        accounts: [],
        tax: [],
        fee_accounts: [],
        terms: [],
        payment_methods: [],
        products: [],
        product_units: [],
        locations: [],
    };

    /**
     * Check if the all list relevant items of storedItem still exist in items fetched from List API.
     * If doesn't exist, means the item is deleted, and so add into relevant arr in invalidObj.
     * @param {*} storedItem local storage item
     * @param {*} namesObjFromList obj containing names fetched from List API. Would contain the autosave_id of storedItem, to do matching.
     * eg {
     *      autosave_id: 0,
     *      account_id: "Sales Income",
     *      location_id: "HQ",
     *      tax_code_id: null
     * }
     * @param {*} dataIndex eg 'bank_items', 'form_items' etc
     * @param {*} idx current idx of storedItem in transaction[data_index]
     * @param {*} bundleChildIdx current idx of storedItem's children
     * @returns true if all list relevant items of storedItem are still valid; false otherwise.
     */
    const shouldKeepItem = (storedItem, namesObjFromList, dataIndex, idx, bundleChildIdx) => {
        const autosavedTextValuesItems = transaction.autosave_text_values[dataIndex];

        const autosavedTextValuesItem = autosavedTextValuesItems.find(
            item => item.autosave_id === namesObjFromList.autosave_id) || {};
        const autosavedChildTextValuesItem = bundleChildIdx ? autosavedTextValuesItems[idx].children.find(
            child => child.autosave_id === namesObjFromList.autosave_id,
        ) || {} : {};

        let shouldKeep = true;
        [
            { id: 'account_id', arrKey: 'accounts', checkChild: true },
            { id: 'tax_code_id', arrKey: 'tax', checkChild: true },
            { id: 'fee_account_id', arrKey: 'fee_accounts' },
            { id: 'payment_method_id', arrKey: 'payment_methods' },
            { id: 'location_id', arrKey: 'locations', checkChild: true },
            { id: 'location2_id', arrKey: 'locations' },
            { id: 'product_id', arrKey: 'products', checkChild: true },
            { id: 'product_unit_id', arrKey: 'product_units', checkChild: true },
            { id: 'term_id', arrKey: 'terms' },
        ]
            .forEach(({ id, checkChild, arrKey }) => {
                // If List doesn't contain the ID of the stored item, means its no longer valid, add into invalidObj.
                // 'shouldKeep' conditional is so that if we found an invalid data, can ignore chekcing remaining ones,
                // since the whole line would already be removed.
                if (storedItem[id] && !namesObjFromList[id] && shouldKeep) {
                    if (checkChild && bundleChildIdx)
                        invalidObj[arrKey].push(autosavedChildTextValuesItem[id]);
                    else
                        invalidObj[arrKey].push(autosavedTextValuesItem[id]);

                    shouldKeep = false;
                }
            });

        return shouldKeep;

        // // account
        // if (storedItem.account_id && !namesObjFromList.account_id) {
        //     if (bundleChildIdx)
        //         invalidObj.accounts.push(autosavedChildTextValuesItem.account_id);
        //     else
        //         invalidObj.accounts.push(autosavedTextValuesItem.account_id);
        // }
        // // tax code
        // else if (storedItem.tax_code_id && !namesObjFromList.tax_code_id) {
        //     if (bundleChildIdx)
        //         invalidObj.tax.push(autosavedChildTextValuesItem.account_id);

        //     else
        //         invalidObj.tax.push(autosavedTextValuesItem.tax_code_id);
        // }
        // // fee acocunt
        // else if (storedItem.fee_account_id && !namesObjFromList.fee_account_id) {
        //     invalidObj.fee_accounts.push(autosavedTextValuesItem.fee_account_id);
        // }
        // // payment method
        // else if (storedItem.payment_method_id && !namesObjFromList.payment_method_id) {
        //     invalidObj.payment_methods.push(autosavedTextValuesItem.payment_method_id);
        // }
        // // location
        // else if (storedItem.location_id && !namesObjFromList.location_id) {
        //     if (bundleChildIdx)
        //         invalidObj.locations.push(autosavedChildTextValuesItem.location_id);

        //     else
        //         invalidObj.locations.push(autosavedTextValuesItem.location_id);
        // }
        // // location2
        // else if (storedItem.location2_id && !namesObjFromList.location2_id) {
        //     invalidObj.locations.push(autosavedTextValuesItem.location2_id);
        // }
        // // product
        // else if (storedItem.product_id && !namesObjFromList.product_id) {
        //     if (bundleChildIdx)
        //         invalidObj.products.push(autosavedChildTextValuesItem.product_id);

        //     else
        //         invalidObj.products.push(autosavedTextValuesItem.product_id);
        // }
        // // product unit
        // else if (storedItem.product_unit_id && !namesObjFromList.product_unit_id) {
        //     if (bundleChildIdx)
        //         invalidObj.product_units.push(autosavedChildTextValuesItem.product_unit_id);

        //     else
        //         invalidObj.product_units.push(autosavedTextValuesItem.product_unit_id);
        // }
        // // term
        // else if (storedItem.term_id && !namesObjFromList.term_id) {
        //     invalidObj.terms.push(autosavedTextValuesItem.term_id);
        // }
        // all stored item ids are still valid. Return true.
        // else {
        //     return true;
        // }

        // return false;
    };

    let getItemsFn;
    switch (type) {
        case 'bank_items':
        case 'journal_items':
            getItemsFn = getBankItemNames;
            break;
        case 'deposit_items':
            getItemsFn = getDepositItemNames;
            break;
        case 'items':
            getItemsFn = getItemNames;
            break;
        case 'term_items':
            getItemsFn = getTermItemNames;
            break;
        case 'form_items':
            getItemsFn = getFormItemNames;
            break;
        default:
            break;
    }

    if (transaction[type]) {
        transaction[type] = transaction[type].filter((item, idx) => {
            const namesObjFromList = getItemsFn(item, item.autosave_id);

            // check each bundle's item (only applicable for form_items)
            if (type === 'form_items' && item.children) {
                item.children = item.children.filter((child, childIdx) => {
                    const childNamesObjFromList = getFormItemNames(child, child.autosave_id);
                    return shouldKeepItem(child, childNamesObjFromList, type, idx, childIdx);
                });
            }

            return shouldKeepItem(item, namesObjFromList, type, idx);
        });
    }

    // const checkBank = type === 'bank_items' && transaction.bank_items;
    // const checkJournal = type === 'journal_items' && transaction.journal_items;
    // if (checkBank || checkJournal) {
    //     const dataIndex = transaction.bank_items ? 'bank_items' : 'journal_items';

    //     transaction[dataIndex] = transaction[dataIndex].filter((item, idx) => {
    //         const fetchedItem = getBankItemNames(item, item.autosave_id);
    //         return shouldKeepItem(item, fetchedItem, dataIndex, idx);
    //     });
    // }

    // const checkDeposit = type === 'deposit_items' && transaction.deposit_items;
    // if (checkDeposit) {
    //     transaction.deposit_items = transaction.deposit_items.filter((item, idx) => {
    //         const fetchedItem = getDepositItemNames(item, item.autosave_id);
    //         return shouldKeepItem(item, fetchedItem, 'deposit_items', idx);
    //     });
    // }

    // const checkStock = type === 'items' && transaction.items;
    // if (checkStock) {
    //     transaction.items = transaction.items.filter((item, idx) => {
    //         const fetchedItem = getItemNames(item, item.autosave_id);
    //         return shouldKeepItem(item, fetchedItem, 'items', idx);
    //     });
    // }

    // const checkForm = type === 'form_items' && transaction.form_items;
    // if (checkForm) {
    //     // transaction.form_items.forEach((item, idx) => {
    //     //     const fetchedItem = getFormItemNames(item, item.autosave_id);

    //     //     // check each bundle's item
    //     //     if (item.children) {
    //     //         item.children.forEach((child, childIdx) => {
    //     //             const childObj = getFormItemNames(child, child.autosave_id);
    //     //             shouldKeepItem(child, childObj, 'form_items', idx, childIdx);
    //     //         });

    //     //     }

    //     //     shouldKeepItem(item, fetchedItem, 'form_items', idx);
    //     // });

    //     transaction.form_items = transaction.form_items.filter((item, idx) => {
    //         const fetchedItem = getFormItemNames(item, item.autosave_id);

    //         // check each bundle's item
    //         if (item.children) {
    //             item.children = item.children.filter((child, childIdx) => {
    //                 const childObj = getFormItemNames(child, child.autosave_id);
    //                 return shouldKeepItem(child, childObj, 'form_items', idx, childIdx);
    //             });
    //         }

    //         return shouldKeepItem(item, fetchedItem, 'form_items', idx);
    //     });
    // }

    // const checkTerm = type === 'term_items' && transaction.term_items;
    // if (checkTerm) {
    //     transaction.term_items = transaction.term_items.filter((item, idx) => {
    //         const fetchedItem = getTermItemNames(item, item.autosave_id);
    //         return shouldKeepItem(item, fetchedItem, 'term_items', idx);
    //     });
    // }

    return invalidObj;
}
